import moment from "moment";
import {
  getActualOrderCompositionAmount,
  getInitialOrderCompositionAmount,
} from "@/utils/orderPaymentSummary";
import { summarizeRefundAmounts } from "@/utils/refundAmountSummary";

export function getDatesFromStartEnd(
  start_date: string,
  end_date: string
): string[] {
  const start = moment(start_date);
  const end = moment(end_date);
  const dates: string[] = [];

  while (start <= end) {
    dates.push(start.format("YYYY-MM-DD"));
    start.add(1, "days");
  }
  return dates;
}

export function groupDateRanges(
  dates: string[]
): { start: string; end: string }[] {
  if (dates.length === 0) return [];

  const sorted = dates
    .map((d) => moment(d).startOf("day"))
    .sort((a, b) => a.diff(b));

  const ranges = [];
  let start = sorted[0];
  let end = sorted[0];

  for (let i = 1; i < sorted.length; i++) {
    const current = sorted[i];
    if (current.diff(end, "days") === 1) {
      end = current;
    } else {
      ranges.push({
        start: start.format("YYYY-MM-DD"),
        end: end.format("YYYY-MM-DD"),
      });
      start = current;
      end = current;
    }
  }

  ranges.push({
    start: start.format("YYYY-MM-DD"),
    end: end.format("YYYY-MM-DD"),
  });

  return ranges;
}

export function groupItems(items: any[]) {
  const results: Record<string, any> = {};
  for (const item of items) {
    const order_place =
      item?.order_place_name ?? (item.order && item.order.order_place_name);
    const order_payment_method = String(
      item?.payment_method_name ??
        item?.order?.payment_method_name ??
        "정보 없음"
    );
    const refund_method = Array.isArray(item?.refund_methods)
      ? item.refund_methods[0] == null
        ? "정보 없음"
        : item.refund_methods.toString()
      : "";

    const initial_order_amount = getInitialOrderCompositionAmount(item);
    const actual_order_amount = getActualOrderCompositionAmount(item);
    const refund_amount = summarizeRefundAmounts([item]).amount;

    const key = `${order_place}-${order_payment_method}-${refund_method}`;
    if (!results[key]) {
      results[key] = {
        order_place: order_place,
        order_payment_method: order_payment_method,
        refund_method: refund_method,
        initial_order_amount: 0,
        actual_order_amount: 0,
        refund_amount: 0,
        order_count: 0,
        refund_count: 0,
        items: [],
      };
    }
    results[key].initial_order_amount += initial_order_amount;
    results[key].actual_order_amount += actual_order_amount;
    results[key].refund_amount += refund_amount;

    if (Array.isArray(item?.refund_methods)) {
      results[key].refund_count += 1;
    } else {
      results[key].order_count += 1;
    }
    results[key].items.push(item);
  }
  return Object.values(results);
}
